/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilelinkdisconnectbody3Inputs */

const en_profilelinkdisconnectbody3 = /** @type {(inputs: Profilelinkdisconnectbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The profile no longer gets requests and no longer sees your events under "Hosting". You can connect it again at any time.`)
};

const de_profilelinkdisconnectbody3 = /** @type {(inputs: Profilelinkdisconnectbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Profil bekommt keine Anfragen mehr und sieht eure Events nicht mehr unter „Veranstaltet“. Du kannst es jederzeit wieder verbinden.`)
};

/**
* | output |
* | --- |
* | "The profile no longer gets requests and no longer sees your events under \"Hosting\". You can connect it again at any time." |
*
* @param {Profilelinkdisconnectbody3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinkdisconnectbody3 = /** @type {((inputs?: Profilelinkdisconnectbody3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinkdisconnectbody3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinkdisconnectbody3(inputs)
	return de_profilelinkdisconnectbody3(inputs)
});
export { profilelinkdisconnectbody3 as "profileLinkDisconnectBody" }